import { NOLA_PHONE, locationSchema } from "../structured-data-core";

export function getSanAntonioStructuredData() {
  const url = "https://restorehair.com/locations/texas/san-antonio/";
  const description =
    "Find out about your hair transplant options in San Antonio with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("San Antonio", "700 N St Mary's St, Suite 1400", "San Antonio", "TX", NOLA_PHONE, url, description),
  ];
}
